<template>
  <div>
    <div
      :class="{
        'w-full h-full left-0 top-0 bg-black bg-opacity-50 backdrop-blur-sm absolute z-20':
          notificationsIsOpen,
      }"
      @click="handleDailyModal"
    ></div>
    <span class="h-full relative flex z-20 justify-center">
      <div class="relative">
        <div
          :class="{
            'w-3 h-3 z-40 animate-ping bg-primary rounded-full top-0 left-0 absolute': true,
            hidden: !cms.haveNewNotifications,
          }"
        ></div>
        <div
          :class="{
            'w-3 h-3 z-40  bg-primary rounded-full top-0 left-0 absolute': true,
            hidden: !cms.haveNewNotifications,
          }"
        ></div>
        <img
          src="~/assets/svg/notifications.svg"
          alt="daily claim"
          :class="{
            'w-6 h-6 lg:w-8 lg:h-8 cursor-pointer':true,
            '!z-20 scale-105 transition-all': notificationsIsOpen,
          }"
          @click="handleDailyModal"
        />
      </div>
      <div
        v-if="notificationsIsOpen"
        class="w-64 lg:w-[28rem] h-auto z-20 p-4 absolute border-2 rounded bg-graybase border-primary flex flex-col gap-4 bottom-0 translate-y-[calc(100%+2rem)]"
      >
        <div class="flex justify-center items-center">
          <Typography size="main-md">Notifications</Typography>
        </div>
        <div class="flex flex-col gap-2 max-h-40 lg:max-h-80 overflow-auto">
          <div :class="{
                 'w-full rounded bg-neutral-950 p-2 px-4 flex justify-between relative cursor-pointer select-none': true,
                 'opacity-50 cursor-default': notification.read,
               }"
               v-for="notification in cms.notifications"
               @click="onNotificationItemClick(notification)"
               :key="notification.id">
            <div
              :class="{
                'w-3 h-3  bg-primary rounded-full top-0 left-0 absolute': true,
                hidden: notification.readed === true,
              }"
            ></div>
            <template v-if="notification.type === 'add-logs'">
              <span>
                <Typography size="main-sm">You have claimed</Typography>
              </span>
              <span class="flex items-center gap-2">
                <img src="~/assets/svg/troncos.svg" class="w-6 h-6" />
                <Typography size="main-md-num">{{
                  notification.content
                }}</Typography>
              </span>
            </template>
            <template v-else>
              <Typography size="main-sm">{{ notification.content }}</Typography>
            </template>
            <div
              :class="{
                'w-3 h-3 animate-ping bg-primary rounded-full top-0 left-0 absolute': true,
                hidden: notification.readed,
              }"
            ></div>
          </div>
        </div>
      </div>
    </span>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import Typography from "./common/Typography.vue";
import { cmsStore } from "../stores/cmsStore";
import { useModalsStore } from "../stores/useModalsStore";

const modalsStore = useModalsStore();
const cms = cmsStore();
const notificationsIsOpen = ref(false);

const getNoReadNotifications = () => {
  return cms.notifications.filter(
    (notification) => notification.readed === false
  );
};

const handleReadNotifications = () => {
  let noReadedNotifications = getNoReadNotifications();
  noReadedNotifications
    .filter((notification) => notification.type !== 'claim-badge')
    .map(async (notification, index) => {
      const response = await cms.readNotification(notification.id);
      cms.updateNotifications()
    });
};

const handleDailyModal = () => {
  notificationsIsOpen.value = !notificationsIsOpen.value;
  if (!notificationsIsOpen.value) {
    handleReadNotifications();
  }else{
    cms.updateNotifications()
  }
};

const onNotificationItemClick = (notification) => {
  if (notification.type === 'claim-badge') {
    const assetsUrl = useRuntimeConfig().public.assetsUrl
    const isProd = !assetsUrl.includes('pre')
    const GOT_AXED_BADGE = 8
    const OTHER_PAGE_BADGE = 47
    const TOMAHAWK_BADGE = 46
    const WOOD_COLLECTOR_BADGE = 48
    const THE_RAIL_BADGE_ID = 49
    const HOT_STREAK_BADGE_ID = 52
    const BORING_SECURITY_BADGE = isProd ? 71 : 66
    const HOT_STREAK_100_BADGE_ID = isProd ? 74 : 70
    const RILLAZ_BADGE_ID = 82
    const RILLAZ_DEPIX_BADGE_ID = 83
    const VERIFIED_ON_CHAIN_BADGE_ID = 77
    
    if (notification.readed) {
      return;
    }
    if (notification.badge_id === GOT_AXED_BADGE) {
      modalsStore.openModal('SUCCESS_CLAIM_GOT_AXED_BADGE', { logs: notification.logs });
    } else if (notification.badge_id === OTHER_PAGE_BADGE) {
      modalsStore.openModal('SUCCESS_CLAIM_OTHER_PAGE_BADGE');
    } else if (notification.badge_id === TOMAHAWK_BADGE) {
      modalsStore.openModal('SUCCESS_CLAIM_TOMAHAWK_BADGE');
    } else if (notification.badge_id === WOOD_COLLECTOR_BADGE) {
      modalsStore.openModal('SUCCESS_CLAIM_WOOD_COLLECTOR_BADGE');
    } else if (notification.badge_id === THE_RAIL_BADGE_ID) {
      modalsStore.openModal('SUCCESS_CLAIM_THE_RAIL_BADGE');
    } else if (notification.badge_id === HOT_STREAK_BADGE_ID) {
      modalsStore.openModal('SUCCESS_CLAIM_HOT_STREAK_BADGE');
    } else if (notification.badge_id === BORING_SECURITY_BADGE) {
      modalsStore.openModal('SUCCESS_CLAIM_BORING_SECURITY_BADGE', { badge_id: notification.badge_id });
    } else if (notification.badge_id === HOT_STREAK_100_BADGE_ID) {
      modalsStore.openModal('SUCCESS_CLAIM_HOT_STREAK_100_BADGE', { badge_id: notification.badge_id });
    } else if (notification.badge_id === VERIFIED_ON_CHAIN_BADGE_ID) {
      modalsStore.openModal('SUCCESS_CLAIM_VERIFIED_ON_CHAIN_BADGE', { badge_id: notification.badge_id });
    } else if (notification.badge_id === RILLAZ_BADGE_ID) {
      modalsStore.openModal('SUCCESS_CLAIM_RILLAZ_BADGE', { badge_id: notification.badge_id });
    } else if (notification.badge_id === RILLAZ_DEPIX_BADGE_ID) {
      modalsStore.openModal('SUCCESS_CLAIM_RILLAZ_DEPIX_BADGE', { badge_id: notification.badge_id });
    }
  }
};

onMounted(async () => {
  await cms.loadNotifications();
});
</script>
